import type { ProductGenre } from '@/app/lib/api/types-api'

/**
 * Lee el primer/único género de `ProductApiItem.genres` (siempre un array en
 * el contrato final del backend, confirmado contra payload real de `/data`
 * para todos sus módulos — specs/033-productos-3-columnas; mismo shape que
 * `PerformanceApiItem.genres`, PDP incluida). `null` sin ningún género.
 * Cada consumidor debe pasar por aquí en vez de leer `genres[0]` a mano, para
 * que el criterio quede en un único sitio.
 */
export function resolveProductGenre(genres: ProductGenre[] | null | undefined): ProductGenre | null {
  return genres?.[0] ?? null
}
